"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnquireMapStateToProps = exports.enquire = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var propertyToPriceShort_1 = require("@/transformers/propertyToPriceShort");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var format_1 = require("@/utils/format");
var EnqurieCallToActionType_1 = require("@/pages/common/states/EnqurieCallToActionType");
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var EnquiryForm_1 = require("@/pages/common/components/EnquiryForm");
var getAllState_1 = require("@/utils/getAllState");
var mapStateToProps = function (state, ownProps) {
    var newEnquiry = ownProps.agentId ? __assign(__assign({}, state.enquire.enquiry), { agentId: ownProps.agentId }) : state.enquire.enquiry;
    var newState = __assign(__assign({}, state.enquire), { enquiry: newEnquiry, user: state.user, symbol: state.layout.currencies.options.find(function (it) { return it.key === state.layout.currencies.currentCurrencyId; }).symbol, currencyMap: state.layout.currencies.options, googleApi: state.layout.googleApi, lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1, currencyId: state.layout.currencies.options.find(function (it) { return it.key === state.layout.currencies.currentCurrencyId; }).key, currentUrl: state.server ? state.server.currentUrl : '', csrfToken: state.csrfToken || '', globalT: state.translate, showComment: ownProps.showComment });
    return newState;
};
exports.EnquireMapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onEnquireCloseClick: function (e) {
        return dispatch(EnquireAction_1.default.onEnquireCloseClick(e.currentTarget.id));
    },
    onEnquireSubmit: function (enquiry, e) { return dispatch(EnquireAction_1.default.onEnqurieSubmit(enquiry, e.currentTarget.id)); },
    onCallToActionClicked: function (type) { return dispatch(EnquireAction_1.default.callToAction(type)); },
}); };
exports.enquire = function (props) {
    var onEnquirePanelClick = function (event) {
        if (event.currentTarget !== event.target)
            return;
        event.persist();
        props.onEnquireCloseClick(event);
    };
    var onEnquireCloseClick = function (event) {
        if (event.currentTarget !== event.target)
            return;
        event.persist();
        props.onEnquireCloseClick(event);
    };
    var onCallClick = function () { return props.onCallToActionClicked(EnqurieCallToActionType_1.EnqurieCallToActionType.Phone); };
    var renderPriceLine = function (item, props) {
        if (item.isSubjectToOffer) {
            return props.t.nameSubjectToOffer;
        }
        return item.available
            ? propertyToPriceShort_1.toPrice(item, props.currencyMap)
            : props.t.nameUnavailable;
    };
    var renderFavorites = function (props) {
        var renderFavoriteItem = function (item, i) {
            return (React.createElement("div", { key: i, className: "c-interested__item" },
                React.createElement("div", { className: "c-interested__name" }, item.building),
                React.createElement("div", { className: "c-interested__type" }, renderPriceLine(item, props))));
        };
        return (React.createElement("div", { className: "c-interested" },
            React.createElement("div", { className: "c-interested__group" },
                React.createElement("div", { className: "c-interested__title" }, props.t.nameFavorite),
                React.createElement("div", { className: "c-interested__items" }, props.favorites.map(renderFavoriteItem)))));
    };
    var currentItem = __assign(__assign({}, props.current), { userPropertyId: 0, available: true, currencyId: props.currencyId });
    var renderCurrent = function (props) {
        var symbol = props.currencyMap.filter(function (it) { return it.key === currentItem.currencyId; })[0].symbol;
        var lang = props.lang;
        var ppsf = currentItem.isSubjectToOffer
            ? ''
            : format_1.default.currencyPpsf(currentItem.pricePerSqft);
        var saGfa = currentItem.sizeSaleable ? props.t.nameSa : props.t.nameGfa;
        ppsf = ppsf ? "@ " + ppsf + " " + saGfa : '';
        var renderLeaseInc = function () {
            if (currentItem.includeManagementFee === ResultPageState_1.ResultIncludeManagementFee.INCLUDE) {
                return (React.createElement("span", { className: "c-resultsm__incl" }, props.tResult.include));
            }
            if (currentItem.includeManagementFee === ResultPageState_1.ResultIncludeManagementFee.EXCLUDE) {
                return (React.createElement("span", { className: "c-resultsm__incl" }, props.tResult.exclude));
            }
        };
        var renderPrice = function () {
            if (currentItem.isSubjectToOffer) {
                return (React.createElement("div", { className: "c-resultsm__price" }, props.t.nameSubjectToOffer));
            }
            return (React.createElement(React.Fragment, null,
                currentItem.salePrice ? (React.createElement("div", { className: "c-resultsm__price" }, format_1.default.currencyDetailSale(currentItem.salePrice, lang, symbol))) : null,
                currentItem.leasePrice ? (React.createElement("div", { className: "c-resultsm__price" },
                    format_1.default.currencyDetailLease(currentItem.leasePrice, lang, symbol),
                    renderLeaseInc())) : null));
        };
        return (React.createElement("div", { className: "c-enquireform__target" },
            React.createElement("div", { className: "c-resultsm" },
                React.createElement("div", { className: "c-resultsm__main" },
                    React.createElement("div", { className: "c-resultsm__name" }, props.current.building),
                    React.createElement("div", { className: "c-resultsm__district" }, props.current.area)),
                React.createElement("div", { className: "c-resultsm__side" }, renderPrice()))));
    };
    var renderReplyBar = function (props) {
        var renderCaptionLg = function (props) {
            return (React.createElement("div", { className: "c-replybar__textLg" },
                React.createElement("div", { className: "c-replybar__captionLg" }, props.replybar.captionLg)));
        };
        var renderTitleAndCaption = function (props) {
            return (React.createElement("div", { className: "c-replybar__text" },
                React.createElement("div", { className: "c-replybar__title" }, props.replybar.title),
                React.createElement("div", { className: "c-replybar__caption" }, props.replybar.caption)));
        };
        var renderTelephone = function (props) {
            var renderButtonBody = function (props) {
                return props.isLoading ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "fal fa-sync fa-spin" }))) : (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "fal fa-phone" }),
                    React.createElement("span", { className: "c-replybar__actiontxt" }, props.t.nameCall)));
            };
            return (React.createElement("a", { id: "enquireTelephone", onClick: onCallClick, className: "c-replybar__action", style: { cursor: 'pointer' } }, renderButtonBody(props)));
        };
        var renderContact = function (props) {
            return (React.createElement("div", { className: "c-replybar__action" },
                React.createElement("span", { className: "fal fa-envelope" }),
                React.createElement("span", { className: "c-replybar__actiontxt" }, props.tForm.nameSubmit)));
        };
        return (React.createElement("div", { className: "c-enquireform__replybar" },
            React.createElement("div", { className: "c-replybar" },
                getAllState_1.showTitleAndCaptionInReplyBar(props.replybar.from) ? renderTitleAndCaption(props) : null,
                getAllState_1.showCaptionLgInReplyBar(props.replybar.from) ? renderCaptionLg(props) : null,
                React.createElement("div", { className: "c-replybar__actions" },
                    props.replybar.phone.isShow && getAllState_1.showCallInReplyBar(props.replybar.from) ? renderTelephone(props) : null,
                    getAllState_1.showContactInReplyBar(props.replybar.from) ? renderContact(props) : null))));
    };
    var enquireForm = props.enquiry;
    return props.isActive ? (React.createElement("div", { id: "enquiryBackground", className: "l-contactpop", onMouseDown: onEnquirePanelClick },
        React.createElement("div", { className: "l-contactpop__panel" },
            React.createElement("div", { className: "l-contactpop__nav" },
                React.createElement("a", { id: "enquiryBack", onClick: onEnquireCloseClick, className: "l-contactpop__back" },
                    React.createElement("span", { className: "fal fa-chevron-left" })),
                React.createElement("div", { className: "l-contactpop__text" }, props.t.nameContactAgent),
                React.createElement("div", { className: "l-contactpop__next" },
                    React.createElement("a", { id: "enquiryClose", onClick: onEnquireCloseClick, className: "l-contactpop__back l-contactpop__back--close", style: { cursor: 'pointer' } },
                        React.createElement("span", { className: "fal fa-times" })))),
            React.createElement("div", { className: "l-contactpop__body" },
                React.createElement("div", { className: "c-enquireform" },
                    React.createElement("div", { className: "c-enquireform__fixhead" }, props.t.nameContactAgent)),
                React.createElement("div", { className: "c-enquireform__main" },
                    props.replybar.isShow ? renderReplyBar(props) : null,
                    props.current && props.current.building ? renderCurrent(props) : null),
                React.createElement("div", { className: "c-enquireform__form" },
                    React.createElement(EnquiryForm_1.default, { showWhatsapp: getAllState_1.showWhatsappInReplyBar(props.replybar.from) })),
                React.createElement("div", { className: "c-enquireform__disclaimer", dangerouslySetInnerHTML: { __html: props.t.namePrivacyPolicy } }))))) : null;
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.enquire);
